var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditColorBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outlined / Content / create") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(-1049.000000, -474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(253.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(20.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(433.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(26.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(299.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Editor-/-format_color_fill",
    transform: "translate(18.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56,8.94 L7.62,0 L6.21,1.41 L8.59,3.79 L3.44,8.94 C2.85,9.53 2.85,10.48 3.44,11.06 L8.94,16.56 C9.23,16.85 9.62,17 10,17 C10.38,17 10.77,16.85 11.06,16.56 L16.56,11.06 C17.15,10.48 17.15,9.53 16.56,8.94 L16.56,8.94 Z M5.21,10 L10,5.21 L14.79,10 L5.21,10 Z M19,11.5 C19,11.5 17,13.67 17,15 C17,16.1 17.9,17 19,17 C20.1,17 21,16.1 21,15 C21,13.67 19,11.5 19,11.5 Z",
    id: "\\uD83D\\uDD39-Primary-Color",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\uD83D\\uDD39-Secondary-Color",
    fill: "#000000",
    points: "0 20 24 20 24 24 0 24"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColorBlack);
export default __webpack_public_path__ + "static/media/edit_color_black.06572962ae56fb9e3a35dd03beb19515.svg";
export { ForwardRef as ReactComponent };